import { reactive } from 'vue';

interface TriggersStore {
    components: Record<string, Record<string, any>>
}

export const triggersStore: TriggersStore = reactive({
    components: {}
});

export function registerComponent(formKey: string, key: string, props: any, ctx: any)
{
    const componentModel = {
        props: props,
        ctx: ctx
    };

    triggersStore.components[formKey] ??= {};
    triggersStore.components[formKey][key] = componentModel;
}

export function unRegisterComponent(formKey: string, key: string)
{
    triggersStore.components[formKey] ??= {};
    delete triggersStore.components[formKey][key];
}

export function getComponent(formKey: string, key: string)
{
    triggersStore.components[formKey] ??= {};

    return triggersStore.components[formKey][key];
}

export function getAllComponents(formKey: string)
{
    triggersStore.components[formKey] ??= {};

    return triggersStore.components[formKey];
}
